import { render, staticRenderFns } from "./MatchingRecordsTab.vue?vue&type=template&id=534caee8&scoped=true"
import script from "./MatchingRecordsTab.component.js?vue&type=script&lang=js&external"
export * from "./MatchingRecordsTab.component.js?vue&type=script&lang=js&external"
import style0 from "./MatchingRecordsTab.vue?vue&type=style&index=0&id=534caee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534caee8",
  null
  
)

export default component.exports